import { useState } from "react";
import { Button, Form } from "react-bootstrap";

import Select from "react-select";

import { useSelector } from "react-redux";
import { reportListConverter } from "../../../../Utils";
import { useNavigate } from "react-router-dom";

const RunNewReport = () => {
  const navigate = useNavigate();
  const chooseReportLabelListRND = reportListConverter(
    useSelector((state) => state.RS_Authentication.reportList)
  );
  const [selectSPApi, setSelectSPApi] = useState(null);

  const handleRun = async () => {
    if (selectSPApi?.value) {
      navigate(selectSPApi?.value)
    }
  };
  const handleReportChange = (e) => {
    if (e?.value) {
      setSelectSPApi(e);
    } else {
      setSelectSPApi(null);
    }
  };

  return (
    <div
      
      style={{ overflowY: "scroll" }}
    >
      <section
        className=" rounded"
        style={{ background: "#eee", minHeight: "92vh" }}
      >
        <article className="container-fluid">
          <div className="p-3 pb-0  mt-1">
            <h6>
            <span className="linkClick" role="button" onClick={() => navigate("/reports-documents-borrower")}>
            Reports & Documents
              </span>{" "}
              / Run New Report
            </h6>
          </div>
        </article>
        <article className="container-fluid">
          <section className="bg-white p-5 my-2 mx-4">
            <div className="col-sm-6">
              <Form.Label className="mt-5">Choose Report</Form.Label>
              <Select
                options={chooseReportLabelListRND?.map(({ value, label }) => ({
                  value,
                  label,
                }))}
                value={selectSPApi ? selectSPApi : null}
                onChange={handleReportChange}
                classNamePrefix="select"
              />
            </div>
            <Button
              className="mt-5 btn btn-primary text-white btn-outline py-3 px-4 me-3"
              onClick={handleRun}
            >
              Run
            </Button>
          </section>
        </article>
      </section>
    </div>
  );
};

export default RunNewReport;
